export enum AllowedFileTypesEnum {
  PDF = 'pdf',
  DOCX = 'docx',
  DOC = 'doc',
  JPG = 'jpg',
  JPEG = 'jpeg',
  PNG = 'png',
  CSV = 'csv',
  XLS = 'xls',
  XLSX = 'xlsx',
}
